/// <reference lib="dom" />
import {
  APP_BRANDS,
  type AppBrand,
  BRICKJOBS_DOMAIN_PATTERNS,
  VIVALDIS_DOMAIN_PATTERNS
} from '../constants'

export const getAppBrandFromHostname = (hostname?: string): AppBrand => {
  if (!hostname) {
    return APP_BRANDS.VivaConnect
  }

  const normalizedHostname = hostname.toLowerCase()
  if (
    BRICKJOBS_DOMAIN_PATTERNS.some(pattern =>
      normalizedHostname.includes(pattern)
    )
  ) {
    return APP_BRANDS.BrickJobs
  }

  if (
    VIVALDIS_DOMAIN_PATTERNS.some(pattern =>
      normalizedHostname.includes(pattern)
    )
  ) {
    return APP_BRANDS.VivaConnect
  }

  return APP_BRANDS.VivaConnect
}

export const getAppBrand = (): AppBrand => {
  try {
    return getAppBrandFromHostname(window.location.hostname)
  } catch {
    return APP_BRANDS.VivaConnect
  }
}
